import { render, staticRenderFns } from "./WheelFortune.vue?vue&type=template&id=28a93b2d&scoped=true"
import script from "./WheelFortune.vue?vue&type=script&lang=js"
export * from "./WheelFortune.vue?vue&type=script&lang=js"
import style0 from "./WheelFortune.vue?vue&type=style&index=0&id=28a93b2d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a93b2d",
  null
  
)

export default component.exports